import {
	Ballot,
	Delete,
	Edit,
	Visibility,
} from "@mui/icons-material";
import { IconButton, Switch, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { TiTick } from "react-icons/ti";
import { SiFoodpanda } from "react-icons/si";

const today = dayjs().$d;
const date =
	today.getFullYear() +
	"-" +
	(today.getMonth() + 1) +
	"-" +
	today.getDate();

export const initFormVals = {
	// activity_id: "1",
	poll_name: "",
	question: "",
	order:"",
	slug: "",
	duration_id: "1",
	start_date: date,
	options: [
		{ option: "", image: null,order:""},
		{ option: "", image: null,order:"" },
	],
	
};

export const initFileVals = {
	preview: "",
	data: "",
};

export const pollsData = (totalPolls, activePolls) => [
	{
		heading: "Total Polls",
		icon: <Ballot fontSize='large' color='secondary' />,
		content: totalPolls,
	},
	{
		heading: "Active Polls",
		icon: <Ballot fontSize='large' color='success' />,
		content: activePolls,
	},
];

export const durations = [
	{
		id: "1",
		duration: "Daily",
	},
	{
		id: "2",
		duration: "Custom",
	},
];

export const getRows = (polls) => {
	const rows = polls.map((item) => {
		return ({
			id: item.id,
			campaign_name: item.campaign_name,
			question: item.question,
			end_date: item.end_date,
			category: item?.category?.name === "Other" ? "POTD" : item?.category?.name,
			start_date: item.start_date,
			responses: item.total_responses ? item.total_responses : "-",
			created_by: item.created_by,
			created_at: item.created_at,
			seo: item.seo,
			status: item.status,
		})
	});
	return rows;
};

export const getColumns = (
	handleStatusChange,
	handleView,
	handleEdit,
	handleDelete,
	admin,
	handleSetSeo
) => {
	const currentDate = new Date();

	let columns = [
		{ field: "id", headerName: "ID", width: 50 },
		{
			field: "campaign_name",
			headerName: "Campaign",
			width: 150,
			editable: false,
		},
		{
			field: "question",
			headerName: "Question",
			sortable: false,
			width: 190,
			editable: false,
		},
		{
			field: "category",
			headerName: "Category",
			sortable: true,
			width: 130,
			editable: false,
		},
		{
			field: "start_date",
			headerName: "Start Date",
			sortable: true,
			width: 130,
			editable: false,
		},
		{
			field: "end_date",
			headerName: "End Date",
			sortable: true,
			width: 130,
			editable: false,
		},
		{
			field: "responses",
			headerName: "Responses",
			sortable: true,
			width: 100,
			editable: false,
		},
		{
			field: "status",
			headerName: "Status",
			sortable: true,
			width: 80,
			editable: false,
			align: "center",
			renderCell: (params) => {
				const endDateArr = params.row.end_date.split("-");
				const formatDate = [
					endDateArr[1],
					endDateArr[0],
					endDateArr[2],
				].join("-");
				const date = new Date(formatDate);
				return (
					<Tooltip title={ params.row.status ? "Active" : "Inactive" }>
						{ admin?.role_id === 1 ? <Switch
							checked={ params.row.status }
							onChange={ () => handleStatusChange(params.id, params.row.status) }
							name='status'
							disabled={ date < currentDate }
						/> : <Ballot color={ params.row.status ? "primary" : "disabled" } /> }
					</Tooltip>
				)
			},
		},
		{
			field: "actions",
			headerName: "Actions",
			width: 120,
			sortable: false,
			renderCell: (params) => {
				const startDateArr = params.row.start_date.split("-");
				const formatDate = [
					startDateArr[1],
					startDateArr[0],
					startDateArr[2],
				].join("-");
				const date = new Date(formatDate);

				return (
					<Box>
						<Tooltip title='View more'>
							<IconButton onClick={ () => handleView(params.id) }>
								<Visibility />
							</IconButton>
						</Tooltip>
						{ ((date > currentDate && admin?.role_id === 1) || admin.role_id === 1) && (
							<Tooltip title='Edit'>
								<IconButton
									onClick={ () => {
										handleEdit(params.id);
									} }>
									<Edit />
								</IconButton>
							</Tooltip>
						) }
						{ !params.row.status && (
							<Tooltip title='Delete'>
								<IconButton
									onClick={ () => {
										handleDelete(params.id);
									} }>
									<Delete />
								</IconButton>
							</Tooltip>
						) }
					</Box>
				);
			},
		},
	];

	const seoField = {
		field: "seo",
		headerName: "SEO",
		sortable: true,
		width: 70,
		editable: false,
		renderCell: (params) => {
			if (params.value) return (
				<Box>
					<Tooltip title='Edit SEO'>
						<IconButton onClick={ () => handleSetSeo(params.id) }>
							<TiTick size={ 24 } />
						</IconButton>
					</Tooltip>
				</Box>
			);
			return (
				<Box>
					<Tooltip title='Set SEO'>
						<IconButton onClick={ () => handleSetSeo(params.id) }>
							<SiFoodpanda fill="#176B87" size={ 20 } />
						</IconButton>
					</Tooltip>
				</Box>
			);
		}
	};

	if (admin?.role_id === 1) {
		const start = columns.slice(0, columns.length-2);
		const end = columns.slice(columns.length - 2);
		columns = [...start, seoField, ...end]
	}
	return columns;
};
